import React from "react";
import { green } from "@mui/material/colors";
import SelectEmployee from "./SelectEmployee";
import { AddMenu } from "components/Meetings/Participants/Menu";
import ViewParticipants from "../../src/components/Meetings/CreateMinutes/ViewParticipants";
import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import CreateModal from "components/Meetings/CreateMeeting/AddParticipant";
import { useHistory } from "react-router-dom";
import SmallModal from "../components/Modal/SmallModel";
import { successToast } from "../helpers/Notification";
import Modal from "../components/Modal/Modal";
import axios from "axios";
import JoditEditorExample from "../helpers/JoditEditorExample";


import {
    Dialog, DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    Chip,
    Box,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    TableContainer,
    Card,
    CardContent,
    CardActions

} from "@mui/material";
import { mapStateToProps } from "../store/helpers/mapState";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { connect } from "react-redux";

const stripHtmlTags = (str) => {
    if (!str) return "";
    return str
        .replace(/<style[^>]*>.*<\/style>/g, "")
        .replace(/<script[^>]*>.*<\/script>/g, "")
        .replace(/<[^>]+>/g, "")
        .replace(/([\r\n]+ +)+/g, "")
        .trim()
        .replace(/Jodit Editor\s*/g, "");
};

const MeetingDetailsDialog = ({
    open,
    onClose,
    meetingDetails,
    resource,
    settings,
    owners,
    setOwners,
    ranks,
    loggedUser,
    systemSettings

}) => {
    const mainBackground = systemSettings?.mainBackground;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [viewParticipants, setViewParticipants] = React.useState(false);
    const [comment, setComment] = React.useState("");
    const [viewComment, setViewComment] = React.useState(false);
    const [selectEmployee, setSelectEmployee] = React.useState(false);
    const [selectUser, setSelectUser] = React.useState(false);
    const [other, setOther] = React.useState(false);
    const [category, setCategory] = React.useState("");
    const [editObject, setEditObject] = React.useState([]);
    const [selectedEmployees, setSelectedEmployees] = React.useState([]);
    const [message, setMessage] = React.useState("");
    const [apply, setApply] = React.useState(false);
    const canAccess = loggedUser?.id === meetingDetails?.creator
    const [select2, setSelect2] = React.useState(false);
    const [content, setContent] = React.useState("");
    const [document, setDocument] = React.useState(null);
    const [status, setStatus] = React.useState("canceled");

    const [select, setSelect] = React.useState(false);
    const [initialParticipants] = React.useState([
        { label: "Name" },
        { label: "Category" },
        { label: "Phone" },
        { label: "Email" }
    ]);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleRemoveEmployee = (index) => {
        const updatedEmployees = selectedEmployees.filter((_, i) => i !== index);
        setSelectedEmployees(updatedEmployees);
    };

    const EditValue = (value) => {
        let array = [...owners];
        let index = array.indexOf(editObject);
        owners[index] = value;
        setEditObject([]);
    };
    let history = useHistory();

    const handleCancelMeeting = async () => {
        try {
            const formData = new FormData();
            formData.append("meetingId", meetingDetails.id);
            formData.append("comment", content);
            formData.append("document", document);

            formData.append("status", status);
            formData.append("participants", JSON.stringify(selectedEmployees));
            const response = await axios.put(
                `/api/meeting/${meetingDetails.id}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            if (response.data.success) {
                setSelectedEmployees([]);
                setContent("");
                setDocument(null);
                setSelect2(false);
                successToast("Meeting updated successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setMessage(response.data.message);
            }
            onClose();
        } catch (error) {
            setMessage(error.response?.data.message || "An error occurred");
        }
    };

    const handleUpdateParticipants = async (participantIds) => {
        try {
            const formData = new FormData();

            const participants = selectedEmployees
                .filter(r => participantIds.includes(r.id))
                .map(r => ({
                    id: r.id,
                    email: r.email,
                    phoneNo: r.phone,
                    names: r.names
                }));

            formData.append('participants', JSON.stringify(participants));

            const response = await axios.put(
                `/api/meeting/${meetingDetails.id}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data.success) {
                setSelectedEmployees([]);
            }
        } catch (error) {
        }
    };

    if (!meetingDetails) {
        return (
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" color="error">
                        No meeting details available.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} variant="contained" sx={{ backgroundColor: "red", color: "#fff" }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    const handleSelectEmployees = (selectedEmployees) => {
        setSelectedEmployees(selectedEmployees);
        setSelectEmployee(false);
    };



    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        border: '1px solid #004d40',
                        borderRadius: '8px',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: '64px',
                            left: '64px',
                            right: '64px',
                        },
                    }
                }}
            >
                <DialogTitle sx={{
                    fontWeight: "bold",
                    padding: '50px 16px 20px 16px'
                }}>
                    Meeting Overview
                </DialogTitle>

                <Box sx={{
                    backgroundColor: "#004d40",
                    color: "#fff",
                    padding: "20px 40px",
                    position: "relative",
                    margin: '2%'
                }}>
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                        {meetingDetails.name || "No Title"}
                    </Typography>
                </Box>

                <DialogContent sx={{
                    padding: '24px 24px',
                    marginBottom: '8px'
                }}>
                    <Grid container spacing={2}
                        sx={{
                            border: '1px solid #004d40',
                        }}
                    >
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1">
                                <strong>Status:</strong>
                                <Chip
                                    label={meetingDetails.status || "Unknown"}
                                    sx={{
                                        marginLeft: '8px',
                                        backgroundColor:
                                            meetingDetails.status === "scheduled"
                                                ? "#ff9800"
                                                : meetingDetails.status === "completed"
                                                    ? "#004d40"
                                                    : meetingDetails.status === "canceled"
                                                        ? "#8d2034"
                                                        : "#9e9e9e",
                                        color: "#fff",
                                        fontWeight: "bold",
                                    }}
                                />
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1">
                                <strong>Start:</strong> {meetingDetails.start ? new Date(meetingDetails.start).toISOString().split('T')[0] : "N/A"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1">
                                <strong>Start:</strong> {meetingDetails.end ? new Date(meetingDetails.end).toISOString().split('T')[0] : "N/A"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Duration:</strong> {meetingDetails.duration || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Room/Venue:</strong> {meetingDetails.venue || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Type:</strong> {meetingDetails.type || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Reminder:</strong> {meetingDetails.reminder || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Agenda:</strong> {stripHtmlTags(meetingDetails.agenda) || "No agenda provided"}</Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Meeting Initiator:</strong> {meetingDetails.createdBy?.Resource.names || "Unknown"}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                            <Typography variant="body1"><strong>Email:</strong> {meetingDetails.createdBy?.Resource.email || "No email available"}</Typography>
                        </Grid>

                        <Grid item xs={12} sx={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                            <Typography variant="body1">
                                <strong>Participants:</strong>
                                {(meetingDetails.MeetingParticipants?.length || 0) + selectedEmployees.length}
                            </Typography>
                            <Button
                                style={{ color:mainBackground }}
                                onClick={() => setViewParticipants(true)}
                            >
                                <i className="fa fa-users fa-md me-1" /> View Participants
                            </Button>
                            {meetingDetails?.status === "scheduled" && (
                                <Button onClick={handleMenuOpen}
                                    style={{ color:mainBackground }}
                                >
                                    <i className="fa fa-plus fa-md me-1 " /> Add New
                                </Button>
                            )}
                        </Grid>


                    </Grid>
                    <Grid item xs={12} sx={{ marginBottom: '16px' }}>

                        <AddMenu
                            anchorEl={anchorEl}
                            handleClose={handleMenuClose}
                            setSelect={setSelectUser}
                            setOther={setOther}
                            setSelectEmployee={setSelectEmployee}
                            setCategory={(e) => {
                                setCategory(e);
                                setSelect(true);
                            }}
                        />
                    </Grid>

                </DialogContent>

                <CreateModal
                    initialState={initialParticipants}
                    editObject={editObject}
                    ranks={ranks}
                    setEditObject={setEditObject}
                    EditValue={EditValue}
                    getValue={(value) => {
                        setOwners((arr) => [...arr, value]);
                    }}
                    toggleModal={setOther}
                    open={other}
                    setSelectedEmployees={setSelectedEmployees}
                    selectedEmployees={selectedEmployees}
                />

                {selectEmployee && (
                    <SelectEmployee
                        confirm={handleSelectEmployees}
                        selectedEmployees={selectedEmployees}
                        settings={settings}
                        open={selectEmployee}
                        onClose={() => setSelectEmployee(false)}
                        resources={resource}
                    />
                )}

                {selectedEmployees?.length > 0 && (
                    <>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        {initialParticipants?.map((v) => (
                                            <TableCell className="text-capitalize" key={v.label}>
                                                {v.label}
                                            </TableCell>
                                        ))}
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedEmployees?.map((user, index) => (
                                        <TableRow key={index}>
                                            <TableCell>#{index + 1}</TableCell>
                                            <TableCell>{user?.names}</TableCell>
                                            <TableCell>{user?.category}</TableCell>
                                            <TableCell>{user?.phone}</TableCell>
                                            <TableCell>{user?.email}</TableCell>
                                            <TableCell>
                                                <div className="grid grid-cols-2 gap-2">
                                                    <AiFillEdit
                                                        onClick={() => {
                                                            setSelectEmployee(true);
                                                        }
                                                        }
                                                        className="cursor-pointer"
                                                    />
                                                    <AiFillDelete
                                                        onClick={() => handleRemoveEmployee(index)}
                                                        className="cursor-pointer"
                                                    />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>)}

                <DialogActions sx={{
                    justifyContent: "center",
                    padding: "16px 24px",
                    gap: "8px",
                    backgroundColor: '#f5f5f5'
                }}>

                    {meetingDetails?.status !== "completed" && canAccess && (
                        <Button
                            color="success"
                            onClick={() => {
                                history.push(`/admin/edit/meeting/${meetingDetails?.id}`);
                            }}
                        >
                            {meetingDetails?.status === "canceled" ? "ReSchedule" : "Edit"}
                        </Button>
                    )}

                    {meetingDetails?.status !== "completed" &&
                        canAccess &&
                        meetingDetails?.status !== "canceled" ? (
                        <Button
                            color={"secondary"}
                            onClick={() => {
                                setStatus("canceled");
                                setSelect2(true);
                                setMessage("Are you sure you want to Cancel the Meeting");
                            }}
                        >
                            Cancel Meeting
                        </Button>
                    ) : null}

                    {selectedEmployees.length > 0 && (
                        <Button
                            color={"success"}
                            onClick={() => {
                                setApply(true);
                                setMessage("Are you sure you want to save the changes");
                            }}
                        >
                            Apply change
                        </Button>
                    )}

                    {apply && (
                        <SmallModal
                            select={apply}
                            setSelect={setApply}
                            confirm={() => {
                                handleUpdateParticipants(selectedEmployees.map(e => e.id));
                                setApply(false);
                                setSelectedEmployees([]);
                                successToast("Meeting updated successfully!", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }}
                        >
                            <i className="fa fa-check-circle fa-4x text-success me-2" />
                            <span>{message}</span>
                        </SmallModal>
                    )}

                    <Modal
                        select={select2}
                        setSelect={setSelect2}
                        title={"Inform Participants"}
                    >
                        <Card>
                            <CardContent>
                                <JoditEditorExample
                                    htmlContent={content}
                                    onBlur={(str) => {
                                        setContent(str.target.value);
                                    }}
                                />
                                <label className="mt-4">Attachment</label>
                                <input
                                    type={"file"}
                                    className="form-control form-control-sm "
                                    onChange={(e) => setDocument(e.target.files)}
                                    multiple
                                />
                            </CardContent>
                            <CardActions className={"float-end"}>
                                <Button onClick={() => setSelect2(false)}>Cancel</Button>
                                <Button
                                    color="success"
                                    onClick={() => {
                                        setSelect2(false);
                                        handleCancelMeeting();
                                    }}
                                >
                                    Confirm
                                </Button>
                            </CardActions>
                        </Card>
                    </Modal>
                </DialogActions>
            </Dialog>

            {viewParticipants && (
                <Dialog
                    open={viewParticipants}
                    onClose={() => setViewParticipants(false)}
                    maxWidth="md"
                    fullWidth
                >
                    {/* <DialogTitle> </DialogTitle> */}
                    <DialogContent>
                        <ViewParticipants
                            participants={[
                                ...(meetingDetails.MeetingParticipants || []),
                                ...selectedEmployees
                            ]}
                            setComment={setComment}
                            setViewComment={setViewComment}
                            systemSettings={systemSettings}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setViewParticipants(false)} variant="contained" sx={{ backgroundColor: green[500], color: "#fff" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            {viewComment && (
                <Dialog
                    open={viewComment}
                    onClose={() => setViewComment(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Comment</DialogTitle>
                    <DialogContent>
                        <Typography>{comment}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setViewComment(false)} variant="contained" sx={{ backgroundColor: green[500], color: "#fff" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>);
};

// export default MeetingDetailsDialog;
export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetailsDialog);